// extracted by mini-css-extract-plugin
module.exports = {"container":"DropdownMenu_container__3BH-j","sending":"DropdownMenu_sending__1iyOY"};